import gsap from "gsap";

export default {
  init() {
    const items = document.querySelectorAll(".accordion__item");

    for (const item of items) {
      let isOpen = false;
      const trigger = item.querySelector(".accordion__item-trigger");
      const triggerIcon = trigger.querySelector("i");
      const content = item.querySelector(".accordion__item-content");

      trigger.addEventListener("click", () => {
        if (!isOpen) {
          isOpen = true;
          content.style.display = "block";
          gsap.to(triggerIcon, {
            duration: 0.2,
            rotation: -90,
            ease: "power2.inOut",
          });
          gsap.fromTo(
            content,
            { opacity: 0, height: 0 },
            {
              duration: 0.2,
              opacity: 1,
              height: "auto",
              ease: "power2.inOut",
            }
          );
        } else {
          isOpen = false;
          gsap.to(triggerIcon, {
            duration: 0.2,
            rotation: 0,
            ease: "power2.inOut",
          });
          gsap.to(content, {
            duration: 0.2,
            opacity: 0,
            height: 0,
            ease: "power2.inOut",
            onComplete: () => {
              content.style.display = "none";
            },
          });
        }
      });
    }
  },
};
